function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1936(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 12.31,
    height: 2.4,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.39999999999999997
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.155,
    y: 1.2
  }, "\n        Alpine\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 2.4,
    width: 12.31,
    height: 10.66,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.155,
    y: 7.73
  }, "\n        Mono\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 13.06,
    width: 12.31,
    height: 22.72,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.0516666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.155,
    y: 24.42
  }, "\n        Sierra\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 35.78,
    width: 12.31,
    height: 32,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.7585714285714287
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.155,
    y: 51.78
  }, "\n        Trinity\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 67.78,
    width: 12.31,
    height: 32.78,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.3677777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.155,
    y: 84.17
  }, "\n        Del_Norte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 100.56,
    width: 12.31,
    height: 37.71,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.0775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.155,
    y: 119.415
  }, "\n        Inyo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 138.27,
    width: 12.31,
    height: 38.65,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.53875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.155,
    y: 157.595
  }, "\n        Mariposa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 176.91,
    width: 12.31,
    height: 42.69,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.462
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.155,
    y: 198.255
  }, "\n        Modoc\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 219.6,
    width: 12.31,
    height: 50.11,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.0516666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.155,
    y: 244.655
  }, "\n        Amador\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 269.71,
    width: 12.31,
    height: 51.79,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.0516666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.155,
    y: 295.60499999999996
  }, "\n        Plumas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 321.5,
    width: 12.31,
    height: 53.29,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.3677777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.155,
    y: 348.145
  }, "\n        Calaveras\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 374.79,
    width: 12.31,
    height: 55.59,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.0775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.155,
    y: 402.58500000000004
  }, "\n        Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 430.38,
    width: 12.31,
    height: 62.45,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.231
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.155,
    y: 461.605
  }, "\n        San_Benito\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 492.84,
    width: 12.31,
    height: 63.53,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.0516666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.155,
    y: 524.605
  }, "\n        Colusa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 556.36,
    width: 12.31,
    height: 68.49,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.53875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.155,
    y: 590.605
  }, "\n        Tuolumne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 624.85,
    width: 12.31,
    height: 75.15,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.462
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.155,
    y: 662.4250000000001
  }, "\n        Glenn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.31,
    y: 0,
    width: 24.87,
    height: 39.4,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.1450000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 24.745,
    y: 19.7
  }, "\n        Lassen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 37.18,
    y: 0,
    width: 25.04,
    height: 39.4,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.782222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 49.7,
    y: 19.7
  }, "\n        El_Dorado\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.22,
    y: 0,
    width: 26.21,
    height: 39.4,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.5525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 75.325,
    y: 19.7
  }, "\n        Yuba\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.43,
    y: 0,
    width: 27.04,
    height: 39.4,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.506666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 101.95,
    y: 19.7
  }, "\n        Sutter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 115.47,
    y: 0,
    width: 28.91,
    height: 39.4,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.818333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 129.925,
    y: 19.7
  }, "\n        Madera\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144.38,
    y: 0,
    width: 29.12,
    height: 39.4,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.8533333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 158.94,
    y: 19.7
  }, "\n        Tehama\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 173.5,
    y: 0,
    width: 33.61,
    height: 39.4,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.601666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 190.305,
    y: 19.7
  }, "\n        Nevada\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 207.11,
    y: 0,
    width: 35.4,
    height: 39.4,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.8999999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 224.81,
    y: 19.7
  }, "\n        Shasta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 242.51,
    y: 0,
    width: 40.97,
    height: 39.4,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.85
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 262.995,
    y: 19.7
  }, "\n        Yolo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 283.47,
    y: 0,
    width: 44.32,
    height: 39.4,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.88
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 305.63000000000005,
    y: 19.7
  }, "\n        Kings\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 327.8,
    y: 0,
    width: 46.7,
    height: 39.4,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 351.15000000000003,
    y: 19.7
  }, "\n        Siskiyou\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 374.5,
    y: 0,
    width: 48.39,
    height: 39.4,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.377777777777777
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 398.695,
    y: 19.7
  }, "\n        Mendocino\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 422.88,
    y: 0,
    width: 48.96,
    height: 39.4,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.566666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 447.36,
    y: 19.7
  }, "\n        Placer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 471.84,
    y: 0,
    width: 48.97,
    height: 39.4,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.85
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 496.325,
    y: 19.7
  }, "\n        Napa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 520.81,
    y: 0,
    width: 58.65,
    height: 39.4,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 550.135,
    y: 19.7
  }, "\n        Imperial\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 579.47,
    y: 0,
    width: 59.71,
    height: 39.4,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.566666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 609.325,
    y: 19.7
  }, "\n        Merced\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 639.17,
    y: 0,
    width: 60.83,
    height: 39.4,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.6266666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 669.5849999999999,
    y: 19.7
  }, "\n        San_Luis_Obispo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.31,
    y: 39.4,
    width: 66.59,
    height: 44.41,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.882
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 45.605000000000004,
    y: 61.605
  }, "\n        Butte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.31,
    y: 83.81,
    width: 66.59,
    height: 48.08,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.013333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 45.605000000000004,
    y: 107.85
  }, "\n        Solano\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.31,
    y: 131.89,
    width: 66.59,
    height: 49.93,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.993
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 45.605000000000004,
    y: 156.855
  }, "\n        Santa_Cruz\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.31,
    y: 181.83,
    width: 66.59,
    height: 51.79,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.358
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 45.605000000000004,
    y: 207.72500000000002
  }, "\n        Marin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.31,
    y: 233.62,
    width: 66.59,
    height: 52.77,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.59625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 45.605000000000004,
    y: 260.005
  }, "\n        Humboldt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.31,
    y: 286.39,
    width: 66.59,
    height: 55.96,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 45.605000000000004,
    y: 314.37
  }, "\n        Monterey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.31,
    y: 342.34,
    width: 66.59,
    height: 59.11,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.444285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 45.605000000000004,
    y: 371.895
  }, "\n        Ventura\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.31,
    y: 401.45,
    width: 66.59,
    height: 67.76,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.659000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 45.605000000000004,
    y: 435.33
  }, "\n        Stanislaus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.31,
    y: 469.21,
    width: 66.59,
    height: 72.62,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.122307692307692
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 45.605000000000004,
    y: 505.52
  }, "\n        Santa_Barbara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.31,
    y: 541.84,
    width: 66.59,
    height: 78.12,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.098333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 45.605000000000004,
    y: 580.9000000000001
  }, "\n        Tulare\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.31,
    y: 619.96,
    width: 66.59,
    height: 80.04,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.098333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 45.605000000000004,
    y: 659.98
  }, "\n        Sonoma\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78.91,
    y: 39.4,
    width: 71.83,
    height: 88.17,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.981111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 114.82499999999999,
    y: 83.485
  }, "\n        Riverside\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 150.74,
    y: 39.4,
    width: 72.61,
    height: 88.17,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 18.1525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 187.04500000000002,
    y: 83.485
  }, "\n        Kern\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 223.35,
    y: 39.4,
    width: 75.77,
    height: 88.17,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.314166666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 261.235,
    y: 83.485
  }, "\n        Contra_Costa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 299.12,
    y: 39.4,
    width: 83.66,
    height: 88.17,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.6054545454545455
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 340.95,
    y: 83.485
  }, "\n        San_Joaquin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 382.78,
    y: 39.4,
    width: 86.87,
    height: 88.17,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.652222222222223
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 426.215,
    y: 83.485
  }, "\n        San_Mateo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 469.65,
    y: 39.4,
    width: 114.26,
    height: 88.17,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.695
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 526.78,
    y: 83.485
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 583.9,
    y: 39.4,
    width: 116.1,
    height: 88.17,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.695
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 641.9499999999999,
    y: 83.485
  }, "\n        Fresno\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78.91,
    y: 127.56,
    width: 92.33,
    height: 114.67,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.595
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 125.07499999999999,
    y: 184.895
  }, "\n        San_Bernardino\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78.91,
    y: 242.23,
    width: 92.33,
    height: 121.04,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.233
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 125.07499999999999,
    y: 302.75
  }, "\n        Sacramento\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78.91,
    y: 363.27,
    width: 92.33,
    height: 131.88,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.393636363636363
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 125.07499999999999,
    y: 429.21
  }, "\n        Santa_Clara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78.91,
    y: 495.16,
    width: 92.33,
    height: 204.84,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.258888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 125.07499999999999,
    y: 597.58
  }, "\n        San_Diego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 171.23,
    y: 127.56,
    width: 248.34,
    height: 175.47,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 25.06714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 295.4,
    y: 215.29500000000002
  }, "\n        Alameda\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 419.58,
    y: 127.56,
    width: 280.42,
    height: 175.47,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.497692307692308
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 559.79,
    y: 215.29500000000002
  }, "\n        San_Francisco\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 171.23,
    y: 303.04,
    width: 528.77,
    height: 396.96,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 36.087272727272726
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 435.615,
    y: 501.52
  }, "\n        Los_Angeles\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1936);
export default __webpack_public_path__ + "static/media/1936.74c90eae5ebf7731bcc580dd7b0e613e.svg";
export { ForwardRef as ReactComponent };